import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Coin from '../Coin';

interface BalanceProps {
  value: number;
}

const Balance: React.FC<BalanceProps> = ({ value }) => {
  const { t } = useTranslation();
  return (
    <Card text="white" className="mb-4">
      <Card.Body
        className="d-flex align-items-center gap-3 rounded-2"
        style={{
          background: 'linear-gradient(135deg, #0A4E86 0%, #0E6BB3 100%)',
          color: '#FFFFFF',
        }}
      >
        <Coin size="lg" />
        <div className="fs-3 fw-bold">
          {t('balance.youHave', { count: value })}
        </div>
      </Card.Body>
    </Card>
  );
};

export default Balance;
